import React from "react";
import { Route, Switch } from "react-router-dom";
import { Path } from "enums";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import ShiftRecordsModule from "modules/records/shift-records/shift-records.module";
import ShiftRecordDetailsModule from "modules/records/shift-records/shift-records-details/shift-details.module";
import DiscountReportModule from "modules/records/discount-report/discount-report.module";

const RecordsPage = () => {
  return (
    <Switch>
      <Route exact path={Path.ShiftRecords} component={ShiftRecordsModule} />
      <Route exact path={Path.ShiftRecordDetails} component={ShiftRecordDetailsModule} />
      <Route exact path={Path.ViewShiftRecordDetails} component={ShiftRecordDetailsModule} />
      <Route exact path={Path.DiscountReport} component={DiscountReportModule} />
      <Redirect to={Path.ShiftRecords} />
    </Switch>
  );
};

export default RecordsPage;
